import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundColor: '#f2f2f2',
  },
  title: {
    color: '#333',
    marginBottom: '1rem',
  },
  logo: {
    marginBottom: '2rem',
    width: '150px',
    height: 'auto',
  },
  button: {
    backgroundColor: '#4285F4',
    color: 'white',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '1rem',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
    transition: 'background-color 0.3s',
    outline: 'none',
  },
  buttonDisabled: {
    backgroundColor: '#D3D3D3',
    cursor: 'default',
  },
  error: {
    color: 'red',
  },
  logoutButton: {
    backgroundColor: '#f44336',
    color: 'white',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '1rem',
    margin: '20px 0',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
  },
};

const Auth = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [session, setSession] = useState(supabase.auth.session);
  const navigate = useNavigate();

  useEffect(() => {
    const { data: authListener } = supabase.auth.onAuthStateChange(
      (event, session) => {
        setSession(session);
      }
    );

    // Automatically navigate when session is set (user is logged in)
    if (session) {
      navigate('/gift-cards');
    }

    return () => {
      if (authListener && authListener.unsubscribe) {
        authListener.unsubscribe();
      }
    };
  }, [session, navigate]); // Depend on `session` and `navigate` to react to changes

  const handleSignIn = async () => {
    try {
      setLoading(true);
      setError('');
      await supabase.auth.signInWithOAuth({
        provider: 'google',
      });
      // Redirection now handled by useEffect watching session
    } catch (error) {
      console.error('Error logging in:', error);
      setError(error.error_description || error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSignOut = async () => {
    try {
      setLoading(true);
      setError('');
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
      // Optionally, handle post-logout logic here
    } catch (error) {
      console.error('Error logging out:', error);
      setError(error.error_description || error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <img
        src="scrip.png"
        alt="Logo"
        style={styles.logo}
      />
      <h1 style={styles.title}>ScripLedger</h1>
      {error && <p style={styles.error}>{error}</p>}
      {!session ? (
        <button
          onClick={handleSignIn}
          style={loading ? { ...styles.button, ...styles.buttonDisabled } : styles.button}
          disabled={loading}
        >
          {loading ? 'Logging in...' : 'Sign in with Google'}
        </button>
      ) : (
        <button
          onClick={handleSignOut}
          style={styles.logoutButton}
          disabled={loading}
        >
          {loading ? 'Logging out...' : 'Sign out'}
        </button>
      )}
    </div>
  );
};

export default Auth;
